import {createTheme} from '@sail/engine';
import {tokens as $} from '@sail/tokens';
import {BadgeConfig} from '../../components/Badge';

const visualRefreshBadgeOverride = BadgeConfig.customize({
  css: {
    border: 'none',
    borderColor: 'none',
    borderRadius: 'rounded',
    backgroundColor: 'currentColor',
    paddingX: 'small',
    paddingY: 'xxsmall',
    backdropFilter: 'blur(1px)',
  },
  variants: {
    type: {
      neutral: {
        css: {
          color: $['color.hue.slate.600'],
          backgroundColor: $['color.hue.slate.33'],
        },
      },
      positive: {
        css: {
          color: $['color.hue.green.600'],
          backgroundColor: $['color.hue.green.33'],
        },
      },
      negative: {
        css: {
          color: $['color.hue.red.600'],
          backgroundColor: $['color.hue.red.33'],
        },
      },
      warning: {
        css: {
          color: $['color.hue.orange.600'],
          backgroundColor: $['color.hue.orange.33'],
        },
      },
      urgent: {
        css: {
          color: $['color.hue.red.0'],
          backgroundColor: $['color.hue.red.600'],
        },
      },
      info: {
        css: {
          color: $['color.hue.blue.600'],
          backgroundColor: $['color.hue.blue.33'],
        },
      },
      new: {
        css: {
          color: $['color.hue.blurple.600'],
          fill: $['color.hue.blurple.600'],
          backgroundColor: $['color.hue.blurple.33'],
        },
      },
    },
  },
});

export const visualRefreshBadgeTheme = createTheme(
  {
    name: 'Visual Refresh Badge',
    description: 'Visual refresh styling for Badge.',
    category: 'Visual Refresh',
    internal: true,
  },
  [visualRefreshBadgeOverride],
);
